import React, { useEffect, useState } from 'react';
import { shallowEqual } from 'react-redux';
import SPImage from '@components/commons/image/SPImage';
import { css } from '@emotion/react';
import theme from '@styles/theme';
import {
  fetchAndActivate,
  getRemoteConfig,
  getString,
} from 'firebase/remote-config';
import { firebaseApp } from '@lib/firebase';
import {
  adSalesImpressionDirect,
  adSalesClickDirect,
  touchADBannerInChat,
} from '@lib/eventManager';
import { useAppSelector } from '@store/hooks';
import { RootState } from '@store/store';
import { BASE_URL } from '@common/values';
import { Story_Play_Type } from '@/baseType';

const ChatADBanner = () => {
  const { playChapterInfo } = useAppSelector(
    (state: RootState) => state.chapter,
    shallowEqual,
  );
  const [isShowBanner, setIsShowBanner] = useState<boolean>(false);

  useEffect(() => {
    const remoteConfig = getRemoteConfig(firebaseApp);
    remoteConfig.defaultConfig = {
      app_status: false,
    };

    fetchAndActivate(remoteConfig)
      .then(() => {
        const isShowAd = getString(remoteConfig, 'show_sp_ad_in_chat');
        setIsShowBanner(JSON.parse(isShowAd));
      })
      .catch((err) => {
        setIsShowBanner(false);
      });
  }, []);

  useEffect(() => {
    if (isShowBanner && playChapterInfo?.chapterOption) {
      adSalesImpressionDirect({
        directAdsId: playChapterInfo.chapterOption.chapterOptionId,
        adTitle: null,
        adUrl: playChapterInfo.chapterOption.bannerImageConnectUrl,
        adLoc:
          playChapterInfo.playChapter.story.playType ===
          Story_Play_Type.Interactive
            ? '회차엔딩-인터랙티브_직광고'
            : '회차엔딩-웹소설_직광고',
        adImageUrl: playChapterInfo.chapterOption.bannerImageFile?.link,
      });
    }
  }, [isShowBanner]);

  function convertDeepLinkToWebLink(deepLink: string) {
    const prefix = `${BASE_URL}/story`;
    const parts = deepLink.split('storyplay://stories');
    const path = parts[1];

    return prefix + path;
  }

  const onClickAdEvent = () => {
    let targetUrl = playChapterInfo?.chapterOption?.bannerImageConnectUrl || '';

    if (targetUrl.includes('storyplay://stories')) {
      targetUrl = convertDeepLinkToWebLink(targetUrl);
    }

    window.open(targetUrl, '_blank', 'noreferrer');

    const url = new URL(targetUrl);
    touchADBannerInChat({
      storyId: playChapterInfo?.playChapter.storyId.toString(),
      storyName: playChapterInfo?.playChapter.story.name,
      chapterIndex: playChapterInfo?.playChapter.chapterIndex.toString(),
      targetUrl: url.host,
    });
    playChapterInfo?.chapterOption &&
      adSalesClickDirect({
        directAdsId: playChapterInfo.chapterOption.chapterOptionId,
        adTitle: null,
        adUrl: playChapterInfo.chapterOption.bannerImageConnectUrl,
        adLoc:
          playChapterInfo.playChapter.story.playType ===
          Story_Play_Type.Interactive
            ? '회차엔딩-인터랙티브_직광고'
            : '회차엔딩-웹소설_직광고',
        adImageUrl: playChapterInfo.chapterOption.bannerImageFile?.link,
      });
  };

  if (!isShowBanner && !playChapterInfo?.chapterOption) {
    return null;
  }

  return (
    <div css={container} onClick={onClickAdEvent}>
      <div className="image-wrapper">
        {playChapterInfo?.chapterOption?.bannerImageFile?.link && (
          <SPImage
            src={playChapterInfo?.chapterOption?.bannerImageFile?.link}
            layout="fill"
            objectFit="cover"
            alt="Chat banner"
          />
        )}
      </div>
    </div>
  );
};

const container = css`
  width: 100%;
  cursor: pointer;
  padding: 0 1rem 0.75rem;

  .image-wrapper {
    border-radius: 0.75em;
    position: relative;
    width: 100%;
    padding-bottom: 30%;
    background-color: ${theme.colors.gray400};

    img {
      border-radius: 0.75em;
    }
  }
`;

// const container = (width: number) => css`
//   position: relative;
//   height: ${width}px;
//   margin: 0.75em 1.25em;
//   border-radius: 0.75em;
//   background-color: ${theme.colors.gray400};
//   cursor: pointer;

//   .img-border {
//     border-radius: 0.75em;
//   }
// `;

export default ChatADBanner;
